import commonActionHeaders from './common-action-headers';

export default [
  {
    text: 'Type',
    value: 'action_type_id',
    sortable: true,
    visible: true,
  },
  {
    text: 'Template',
    value: 'template.description',
    sortable: false,
    visible: true,
  },
  {
    text: 'Email Subject/Text Body',
    value: 'template.subject',
    sortable: false,
    visible: true,
  },
  {
    text: 'Notes',
    value: 'notes',
    sortable: false,
    visible: true,
  },
  ...commonActionHeaders,
];
